import React, { useEffect } from 'react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { InviteSection } from './LandingTemplate';
import { setCanonical } from '../lib/seo';

const SERIF = "'Cormorant Garamond', serif";

const HowItWorks = () => {
  useEffect(() => {
    document.title = 'How It Works | Archen™';
    setCanonical('/how-it-works');
    if (window.location.hash === '#demo') {
      setTimeout(() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' }), 300);
    }
  }, []);

  return (
    <div className="bg-[#FDF8F3] min-h-screen antialiased" data-testid="how-it-works">
      <Header />
      <main>
        <section className="pt-36 md:pt-44 pb-10 md:pb-14">
          <div className="content-container text-center">
            <p className="text-[#7A5A2E] text-[11px] tracking-[0.24em] uppercase mb-6">How It Works</p>
            <h1 className="mx-auto text-[#1F1812] leading-[1.05] tracking-[-0.02em]" style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 'clamp(2.6rem, 5vw, 4.2rem)', maxWidth: '20ch' }}>
              Your inbox is already the record.
            </h1>
            <p className="mt-7 mx-auto text-[#3D3A36] text-[18px] md:text-[20px] leading-[1.6] max-w-[60ch]">
              Every decision, approval, and deadline your studio sends lives inside email. Archen™ reads it and keeps the record current. When the invoice dispute comes, this is what you reach for.
            </p>
            <a
              href="#demo"
              data-testid="hero-see-it-work-cue"
              onClick={(e) => { e.preventDefault(); document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group mt-8 inline-flex items-center gap-1.5 text-[#7A5A2E] text-[12px] tracking-[0.16em] uppercase transition-colors hover:text-[#5C4322]"
            >
              See it work
              <span className="transition-transform duration-200 group-hover:translate-y-0.5">&#8595;</span>
            </a>
          </div>
        </section>

        {/* The widget's only home */}
        <section id="demo" style={{ scrollMarginTop: '96px' }} className="pb-24 md:pb-32">
          <div className="content-container">
            <div className="rounded-[24px] overflow-hidden border border-[#EAE0D2] shadow-[0_24px_60px_-30px_rgba(60,45,30,0.35)]">
              <archen-thread-demo
                eyebrow="See it work"
                heading="Watch Archen™ read a real thread."
                lede="No setup, no sign-in. Pick a thread and watch every decision, approval, and deadline surface, each one quoting the line it came from."
                cta="Apply to join the Founding 50"
                cta-href="archen.io/foundingdesigner"
              ></archen-thread-demo>
            </div>
          </div>
        </section>

        <InviteSection s={{
          eyebrow: 'Founding 50',
          h2: 'You are invited to help shape what comes next.',
          h2Max: '30ch',
          blocks: [
            { text: 'Fifty founding firms. A direct line to the team, a real say in the roadmap, and the first look at everything new, the self-updating client portal included.' },
            { text: 'Fifty seats. Applications are open now.' },
          ],
          footnote: '50 founding firms · Direct access to the team · A voice in what we build next',
        }} />
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorks;
